/**
 * WinterManager class to handle scrolling of a specific container into view after interactions
 * Usage: Instantiate with the container element and optional delay
 * Example:
 *   const winterManager = new WinterManager(document.getElementById("gs_wintermanager"), 500);
 */
export default class WinterManager {

    /**
     * @param {*} container - HTMLElement to manage visibility
     * @param {*} delay - delay in milliseconds before checking visibility ( default: 500ms )
     */
    constructor(container, delay) {
        this.container = document.getElementById("gs_wintermanager");
        this.delay = delay || 500;

        container.addEventListener("click", e => {
            console.log("WinterManager: click detected, checking visibility after delay of " + this.delay + "ms");
            setTimeout(() => {
                this.isInViewport(document.getElementById("gs_wintermanager")).then(isVisible => {
                    container.visible = isVisible;
                    if(!container.visible) {
                        console.log("scrolling container into view");
                        container.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                    console.log("container visible:", container.visible); // true / false
                });
            }, this.delay);
        });
    }

    /**
     * checks if element is in viewport
     * @param {HTMLElement} element - element to check
     * @returns {Promise} - resolves to true if element is in viewport, false otherwise
    */
    isInViewport(element) {
        return new Promise((resolve) => {
            const observer = new IntersectionObserver(([entry]) => {
                resolve(entry.isIntersecting);
                observer.disconnect();
            });
            observer.observe(element);
        });
    }
}
